<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'custom-fields' }">Custom Fields</el-breadcrumb-item>
            <el-breadcrumb-item v-if="$route.params.fieldId">Edit</el-breadcrumb-item>
            <el-breadcrumb-item v-else>Create</el-breadcrumb-item>
        </el-breadcrumb>

        <card class="mt-3">
            <!-- <template slot="header">
                <span v-if="$route.params.fieldId">Edit Field</span>
                <span v-else>New Custom Field</span>
            </template> -->

            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
            <div v-else>
                <el-form :model="field" :rules="rules" label-width="300px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                    <el-form-item label="Title*">
                        <el-input v-model="field.title"/>
                    </el-form-item>
                    <el-form-item label="Name*" prop="name">
                        <el-input
                            v-model="field.name"
                            placeholder=""/>
                    </el-form-item>
                    <el-form-item label="Type*">
                        <el-select v-model="field.type">
                            <el-option
                                v-for="(type, index) in types"
                                :key="`type-${index}`"
                                :value="type.value"
                                :label="type.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Add To Mass-Email & Template Filter">
                        <el-radio-group v-model="field.addToMassEmailAndTemplateFilter">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="Required">
                        <el-radio-group v-model="field.required">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="Published">
                        <el-radio-group v-model="field.published">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Registrant Editable">
                        <el-radio-group v-model="field.registrantEditable">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item v-if="['list', 'text', 'textarea'].includes(field.type)" label="Special Admin Privilege needed to Edit">
                        <el-radio-group v-model="field.specialPrivilegeNeededToEdit">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="Registrant Editable during Edit Registration (Existing Registrant)">
                        <el-radio-group v-model="field.registrantEditableDuringEditRegistration">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Use primary registrant data for child registrants(if not available) for badge printing">
                        <el-radio-group v-model="field.pullParentDataIfNotAvailable">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="Show on Registration Screen">
                        <el-radio-group v-model="field.showOnRegistrationScreen">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Enable this field for duplicate check">
                        <el-radio-group v-model="field.enableFieldForDuplicateCheck">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="Hide on E-Mail">
                        <el-radio-group v-model="field.hideOnEmail">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="Hide on Export / Report">
                        <el-radio-group v-model="field.hideOnExport">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="Show Totals on Report">
                        <el-radio-group v-model="field.showTotalsOnReport">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="field.showTotalsOnReport"
                        label="Total Type on Report">
                            <el-radio-group v-model="field.showCount">
                                <el-radio-button :label="false">Total</el-radio-button>
                                <el-radio-button :label="true">Count</el-radio-button>
                            </el-radio-group>
                    </el-form-item>

                    <el-form-item v-if="field.type == 'checkboxes'" label="Sort In Reports Using Values">
                        <el-radio-group v-model="field.sortUsingValuesWhileSaving">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Description">
                        <el-input
                            v-model="field.description"
                            type="textarea"
                            rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="field.type === 'list'"
                        label="Multiple">
                            <el-radio-group v-model="field.multiple">
                                    <el-radio-button :label="false">No</el-radio-button>
                                    <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>

                    <el-form-item
                        v-if="['checkboxes', 'list', 'radio'].includes(field.type)"
                        label="Labels">
                            <el-input
                                v-model="field.labels"
                                type="textarea"
                                rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="['checkboxes', 'list', 'radio'].includes(field.type)"
                        label="Values">
                            <el-input
                                v-model="field.values"
                                type="textarea"
                                rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="['integer'].includes(field.type)"
                        label="Min Value">
                            <el-input
                                v-model="field.validations.min"
                                type="number"/>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="['integer'].includes(field.type)"
                        label="Max Value">
                            <el-input
                                v-model="field.validations.max"
                                type="number"/>
                    </el-form-item>

                    <el-form-item
                        v-if="['text'].includes(field.type)"
                        label="URL">
                            <el-radio-group v-model="field.validations.url">
                                <el-radio-button :label="false">No</el-radio-button>
                                <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="['integer'].includes(field.type)"
                        label="Integer">
                            <el-radio-group v-model="field.validations.integer">
                                <el-radio-button :label="false">No</el-radio-button>
                                <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="['text'].includes(field.type)"
                        label="E-Mail">
                            <el-radio-group v-model="field.validations.integer">
                                <el-radio-button :label="false">No</el-radio-button>
                                <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="['calendar'].includes(field.type)"
                        label="Past Date">
                            <el-radio-group v-model="field.validations.pastDate">
                                <el-radio-button :label="false">No</el-radio-button>
                                <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="['text'].includes(field.type)"
                        label="IP">
                            <el-radio-group v-model="field.validations.ip">
                                <el-radio-button :label="false">No</el-radio-button>
                                <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="['color', 'integer', 'radio', 'text', 'textarea', 'calendar'].includes(field.type) || (field.type === 'list' && field.multiple === false)"
                        label="Default Value">
                            <el-input
                                v-if="field.type === 'textarea'"
                                v-model="field.defaultValue"
                                type="textarea"
                                rows="5"/>
                            <el-input
                                v-else-if="field.type === 'integer'"
                                v-model="field.defaultValue"
                                type="number"/>
                            <el-date-picker
                                v-else-if="field.type === 'calendar'"
                                v-model="field.defaultValue"
                                placeholder="Choose Date"></el-date-picker>
                            <el-input
                                v-else
                                v-model="field.defaultValue"/>
                    </el-form-item>
                    
                    <el-form-item
                        v-if="field.type === 'checkboxes' || (field.type === 'list' && field.multiple === true)"
                        label="Default Values">
                            <el-input
                                v-model="field.defaultValue"
                                type="textarea"
                                rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="field.type === 'list' || field.type === 'radio' || field.type === 'checkboxes'"
                        label="Fee Field">
                            <el-radio-group v-model="field.feeField">
                                <el-radio-button :label="false">No</el-radio-button>
                                <el-radio-button :label="true">Yes</el-radio-button>
                            </el-radio-group>
                    </el-form-item>

                    <el-form-item
                        v-if="field.feeField"
                        label="Fee Values">
                            <el-input
                                v-model="field.feeValues"
                                type="textarea"
                                rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="field.feeField"
                        label="Discount">
                            <el-checkbox v-model="field.discount">
                                    Has Discount?
                                </el-checkbox>
                    </el-form-item>
                    <el-form-item v-if="field.discount" label="Discount Type" label-width="30%">
                        <el-radio v-if="field.discount" v-model="field.discountType" label="amount">Amount</el-radio>
                        <el-radio v-if="field.discount" v-model="field.discountType" label="percent">Percent</el-radio>
                    </el-form-item>
                    <el-form-item v-if="field.discount" label="Discount Period?" label-width="30%">
                        <el-radio v-if="field.discount" v-model="field.discountPeriod" :label="true" @change="isPeriod(true)">Yes</el-radio>
                        <el-radio v-if="field.discount" v-model="field.discountPeriod" :label="false" @change="isPeriod(false)">No</el-radio>
                    </el-form-item>
                    <div class="fees-discount-block">
                      <div v-for="(item, index) in discountPeriodSet" class="discount-container">
                          <el-form-item v-if="field.discountPeriod==true && field.discount" label="Start Date" label-width="30%">
                              <el-date-picker v-model="field.discountStartDate[index]" type="datetime"/>
                          </el-form-item>
                          <el-form-item v-if="field.discountPeriod==true && field.discount" label="End Date" label-width="30%">
                              <el-date-picker v-model="field.discountEndDate[index]" type="datetime"/>
                          </el-form-item>
                          <el-form-item v-if="field.discount" label="Discount Value"  label-width="30%">
                              <el-input v-model="field.discountValue[index]" type="textarea"
                                rows="5"/>
                          </el-form-item>
                          <el-form-item class="border-bottom" />
                      </div>
                    </div>

                    <el-form-item v-if="field.discountPeriod==true && field.discount" label-width="30%">
                        <el-button
                            type="primary"
                            class="btn btn-primary"
                            @click="addPeriod()">
                                Add Period
                        </el-button>
                    </el-form-item>

                    <el-form-item
                        v-if="field.feeField"
                        label="Fee Formula">
                            <el-input v-model="field.feeFormula"/>
                    </el-form-item>

                    <el-form-item label="Quantity Field">
                        <el-radio-group v-model="field.quantityField">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item
                        v-if="field.quantityField"
                        label="Quantity Values">
                            <el-input
                                v-model="field.quantityValues"
                                type="textarea"
                                rows="5"/>
                    </el-form-item>

                    <el-form-item label="Field Mapping">
                        <el-select v-model="field.fieldMapping">
                            <el-option
                                v-for="type in mappingTypes"
                                :key="`fields-mapping-type-${type.value}`"
                                :label="type.label"
                                :value="type.value"/>
                            <el-option
                                label="None"
                                :value="null"/>
                        </el-select>
                    </el-form-item>

                    <!-- Depends on Fields -->
                    <el-form-item
                        v-for="(dependance, index) in field.dependsOnFields"
                        :key="`dependance-${index}`"
                        :label="`${ index ? 'OR' : '' } Depends on field ${ index ? index + 1 : '' }`">
                            <el-select v-model="field.dependsOnFields[index]">
                                <el-option
                                    v-for="(field, index) in fields"
                                    v-if="['radio', 'checkboxes', 'list'].includes(field.type)"
                                    :key="`field-${field._id}`"
                                    :value="index"
                                    :label="field.title"/>
                                <el-option :value="null" label="None"></el-option>
                            </el-select>
                            <el-select
                                v-if="dependance !== null"
                                v-model="field.dependsOnValues[index]"
                                placeholder="Depends on Value"
                                class="ml-2">
                                    <el-option
                                        v-for="(value, index) in fields[dependance].values.split('\n')"
                                        :key="`field-value-${value}`"
                                        :value="value"
                                        :label="fields[dependance].labels.split('\n')[index]"/>
                                    <el-option :value="null" label="None"></el-option>
                            </el-select>
                            <!-- <el-select
                                
                                v-model="field.showFrom[index]"
                                placeholder="Show From"
                                class="ml-2">
                                    <el-option value="label" label="Label"></el-option>
                                    <el-option value="value" label="Value"></el-option>
                            </el-select> -->
                            <el-button
                                class="ml-2"
                                @click="removeDependency(index)">
                                    <fa icon="times"/>
                            </el-button>
                    </el-form-item>
                    <div class="row">
                        <label class="col-sm-2 col-form-label"></label>
                        <div class="col-sm-10">
                            <el-button @click="newDependance()">New Dependance</el-button>
                        </div>
                    </div>
                </el-form>
            </div>
            <template slot="footer">
                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="saving"
                        @click="propagateDialog = true">
                            Save
                    </el-button>
                </div>
            </template>
            <!-- <tabs type="primary" v-model="currentTab" @click="changeTab">
                <tab-pane id="general_information" label="General Information">
                </tab-pane>
                <tab-pane id="custom_db_widget" label="Custom Dashboard Widget">
                    <div class="d-flex justify-content-end mb-3">
                        <el-button class="btn btn-primary" @click="addNewWidget=true">New</el-button>
                    </div>
                    <el-table :data="widgets">
                        <el-table-column label="Title" prop="title" min-width="200px"/>
                        <el-table-column label="Enabled" prop="enabled" min-width="200px"/>
                       
                        <el-table-column label="Actions" min-width="300px">
                            <template slot-scope="props">
                                <router-link
                                    v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editCustomFields)"
                                    :to="{ name: 'custom-fields-edit', params: { fieldId: props.row._id } }">
                                        <el-tooltip content="Edit" placement="top">
                                            <el-button class="btn" title="Edit">
                                                <fa :icon="['fas', 'pen']"/>
                                            </el-button>
                                        </el-tooltip>
                                </router-link>
                                <el-tooltip content="Clone" placement="top">
                                    <el-button
                                        @click="clone(props.row._id)"
                                        class="btn ml-1"
                                        title="Clone"
                                        :loading="cloning[props.row._id]">
                                            <fa icon="copy"/>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="Delete" placement="top">
                                    <el-button
                                        @click="remove(props.row._id)"
                                        class="btn btn-danger ml-1"
                                        title="Delete">
                                            <fa :icon="['fas', 'trash']"/>
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </tab-pane>
            </tabs> -->

        </card>

        <el-dialog
            title="Propagation"
            :visible.sync="propagateDialog"
        >
            <el-form label-width="300px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                <label style="display: block; margin-bottom: 6px;">
                    <input type="radio" name="propagateChanges" :value="false" v-model="propagateChanges" style="margin-right: 6px;">
                    <span>Do not propagate changes to registration types</span>
                </label>

                <label style="display: block;">
                    <input type="radio" name="propagateChanges" :value="true" v-model="propagateChanges" style="margin-right: 6px;">
                    Propagate changes to registration types
                </label>
                <!-- <el-form-item label="Enabled">
                    <el-radio-group v-model="propagateChanges">
                    </el-radio-group>
                </el-form-item> -->

                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="saving"
                        @click="submit">
                            Proceed
                    </el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    mounted () {
        this.getData()
    },
    computed: {
        ...mapState([
            'fields'
        ])
    },
    data () {
        const checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('Please input name'))
            }

            setTimeout(() => {
                if (/\s/.test(value)) {
                    callback(new Error('Name should not contain empty space'))
                } else {
                    callback()
                }
            }, 100)
        }

        return {
            rules: {
                name: [
                    { validator: checkName, trigger: 'blur' }
                ]
            },
            types: [
                { label: 'Calendar', value: 'calendar' },
                { label: 'Checkboxes', value: 'checkboxes' },
                { label: 'Color', value: 'color' },
                { label: 'Editor', value: 'editor' },
                { label: 'Integer', value: 'integer' },
                { label: 'List', value: 'list' },
                { label: 'Media', value: 'media' },
                { label: 'Radio', value: 'radio' },
                { label: 'Text', value: 'text' },
                { label: 'Text Area', value: 'textarea' }
            ],
            mappingTypes: [
                { label: 'E-Mail', value: 'email' },
                { label: 'Phone', value: 'phone' },
                { label: 'Title', value: 'title' },
                { label: 'First Name', value: 'firstName' },
                { label: 'Last Name', value: 'lastName' },
                { label: 'Address Line 1', value: 'address1' },
                { label: 'Address Line 2', value: 'address2' },
                { label: 'State', value: 'state' },
                { label: 'City', value: 'city' },
                { label: 'ZIP', value: 'zip' },
                { label: 'Country', value: 'country' },
            ],
            field: {
                eventId: this.$route.params.eventId,
                title: '',
                name: '',
                description: '',
                type: null,
                multiple: false,
                validations: {
                    min: null,
                    max: null,
                    url: false,
                    integer: false,
                    email: false,
                    pastDate: false,
                    ip: false
                },
                labels: '', // labels for dropdown
                values: '', // values for dropdown
                defaultValue: '', // default value for text input
                required: false,
                published: true,
                registrantEditable: true,
                registrantEditableDuringEditRegistration: true,
                pullParentDataIfNotAvailable: false,
                showOnRegistrationScreen: true,
                hideOnEmail: false,
                hideOnExport: false,
                fieldMapping: null,
                showTotalsOnReport: false,
                showCount: false,
                feeField: false,
                feeValues: '',
                feeFormula: '',
                quantityField: false,
                quantityValues: '',
                dependsOnFields: [],
                dependsOnValues: [],
                discount: false,
                discountType: 'amount',
                discountValue: [],
                discountPeriod: false,
                discountStartDate: [],
                discountEndDate: [],
            },
            saving: false,
            loading: false,
            discountPeriodSet: 1,
            addNewWidget: false,
            widgets: [],
            propagateChanges: false,
            propagateDialog: false,
        }
    },
    methods: {
        submit: async function () {
            this.saving = true
            try {
                if(!this.field.multiple && this.field.type == 'list'){
                    this.field.sortUsingValuesWhileSaving = false
                }
                const data = {
                    ...this.field,
                    dependsOnFields: this.field.dependsOnFields.map(fieldIndex => this.fields[fieldIndex]),
                    propagateChanges: this.propagateChanges,
                }

                if (this.$route.params.fieldId) {
                    await this.$store.dispatch('update', {
                        path: 'fields',
                        id: this.$route.params.fieldId,
                        data
                    })

                    this.$notify('Information successfully updated!')
                } else {
                    await this.$store.dispatch('create', {
                        path: 'fields',
                        data
                    })
    
                    this.$router.push({ name: 'custom-fields' })
                    this.$notify('New field was successfully created!')
                }
            } catch (e) {
                console.log(e)
                console.log('error creating field')
            }
            this.saving = false
            this.propagateDialog = false
        },
        getData: async function () {
            this.loading = true
            try {
                let params = { filters: { eventId: this.$route.params.eventId } }
                await this.$store.dispatch('getAll', { path: 'fields', params })

                if (this.$route.params.fieldId) {
                    const response = await this.$store.dispatch('get', { path: 'fields', key: 'field', id: this.$route.params.fieldId })
                    let field = response.data.field
                    field.dependsOnFields = field.dependsOnFields.map(field => this.fields.findIndex(f => f._id === field)).filter(index => index !== -1)
                    
                    //Populate discount value                    
                    let discount_obj = response.data.discount?[...response.data.discount]:[]
                    let discount = discount_obj.length?true:false;
                    this.discountPeriodSet = discount_obj.length==0?1:discount_obj.length;
                    let discountValue = []
                    let discountStartDate = []
                    let discountEndDate = []
                    let discountType = 'amount';
                    let discountPeriod = false;
                    if(discount_obj.length){
                        discountType = discount_obj[0].discountType;
                        discountPeriod = Boolean(discount_obj[0].discountPeriod)
                        discount_obj.map(e=>{
                            discountValue.push(e.discountValue)
                            discountStartDate.push(e.discountStartDate)
                            discountEndDate.push(e.discountEndDate)
                        })
                    }

                    this.field = {
                        discount,
                        discountType,
                        discountPeriod,
                        discountValue,
                        discountStartDate,
                        discountEndDate,
                        ...field
                    }
                }
            } catch (e) {
                console.log(e)
                console.log('error getting field')
            }

            this.loading = false
        },
        newDependance: function () {
            if (!this.field.dependsOnFields.length || this.field.dependsOnFields[this.field.dependsOnFields.length - 1] !== null) {
                this.field.dependsOnFields.push(0)
                this.field.dependsOnValues.push('')
            }
        },
        removeDependency: function (i) {
            this.field.dependsOnFields = this.field.dependsOnFields.filter((field, index) => index !== i)
            this.field.dependsOnValues = this.field.dependsOnValues.filter((field, index) => index !== i)
        },
        addPeriod: function(){
            this.discountPeriodSet++;
        },
        isPeriod:function(value){
            if(!value)
                this.discountPeriodSet = 1
        }
    }
}
</script>
